// src/index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Suppress Firebase Analytics auto-init errors — we use Firestore-based analytics instead
window.addEventListener("unhandledrejection", (event) => {
  const msg = event.reason?.message || "";
  if (msg.includes("analytics") || msg.includes("config-fetch-failed")) {
    event.preventDefault();
  }
});

// Get the root element and ensure it exists
const container = document.getElementById("root");

if (!container) {
  throw new Error(
    'Failed to find the root element. Make sure you have a div with id="root" in your public/index.html'
  );
}

// Create root and render the app
const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// No service worker: this site is CMS-driven, so content freshness matters far
// more than offline support. A cached app shell meant edits (palette, copy,
// projects) only reached returning visitors after they closed every tab.
// Repeat loads stay instant via the localStorage cache in usePortfolio.
// unregister() also removes any worker previously installed on a visitor's device.
serviceWorkerRegistration.unregister();
